import { defineComponent } from 'vue';
import { setupComponent } from '@studyportals/vue-platform';
import { CountryCB } from './CountryCB';
import NoVisaInformation from '@/presentation/components/no-visa-information/NoVisaInformation.vue';
import NoVisaRequired from '@/presentation/components/no-visa-required/NoVisaRequired.vue';
import SectionContent from '@/presentation/components/section-content/SectionContent.vue';

export default defineComponent({
	components: {
		NoVisaInformation,
		NoVisaRequired,
		SectionContent,
	},
	setup: () => {
		const codeBehind = new CountryCB();

		return setupComponent(codeBehind);
	},
});
